// extracted by mini-css-extract-plugin
export default {"container":"zoom-level-toggle_container__E7JJ0"};